/**
 * Up to two upper-case initials for an owner name or entity ref:
 * 'Platform Team' -> 'PT', 'group:default/foo-bar' -> 'FB'. '?' when empty.
 */
export function ownerInitials(name: string): string {
  const base = name.slice(name.lastIndexOf('/') + 1);
  const initials = base
    .split(/[\s\-_]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0].toLocaleUpperCase('en-US'))
    .join('');
  return initials || '?';
}
